"use client";

import React, { ButtonHTMLAttributes } from "react";
import styles from "./Button.module.css";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?:
  | "success"
  | "primary"
  | "secondary"
  | "danger"
  | "yellow"
  | "outline"
  | "ghost"
  | "link"
  | "text"
  | "paginationButton"
  | "spinner"
  size?: "small" | "medium" | "large";
  shape?: "default" | "rounded" | "circle";
  isLoading?: boolean;
  icon?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
}

const Button: React.FC<ButtonProps> = ({
  type = "button",
  variant = "primary",
  size = "medium",
  shape = "default",
  isLoading = false,
  icon,
  children,
  className = "",
  ...rest
}) => {
  return (
    <button
      type={type}
      className={`
        ${styles.button}
        ${styles[variant]}
        ${styles[size]}
        ${styles[shape]}
        ${isLoading ? styles.disabled : ""}
        ${className}
      `}
      disabled={isLoading || rest.disabled}
      {...rest}
    >
      {isLoading && <span className={styles.spinner}></span>}
      {icon && <span className={styles.icon}>{icon}</span>}
      {children}
    </button>
  );
};

export default Button;
